type ObjStringMessage = Readonly<{
  message: string;
}>;

const isObjWithStringMessage = (value: unknown): value is ObjStringMessage => value != null
  && typeof value === 'object'
  && 'message' in value
  && typeof value.message === 'string';

const parseJSONObj = (value: unknown): object => {
  try {
    if (typeof value === 'object' && value != null) return value;
    return typeof value === 'string' ? parseJSONObj(JSON.parse(value) as unknown) : {};
  } catch {
    return {};
  }
};

export const findErrMsg = (value: unknown): string | undefined => {
  const stack: unknown[] = [ parseJSONObj(value) ]; // Stack for DFS

  while (stack.length > 0) {
    const current = stack.pop();

    // Check if current is an object (excluding null) with a "message" key of type string
    if (typeof current === 'object' && current !== null) {
      if (isObjWithStringMessage(current)) return current.message;

      // If current is an array, add its elements to the stack for DFS
      if (Array.isArray(current)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        stack.push(...current);
      } else {
        // Push properties of current object to the stack for DFS
        for (const key in current) {
          stack.push((current as Record<string, unknown>)[key]);
        }
      }
    }
  }

  return undefined; // No "message" string found
};
